import React, { useCallback, useEffect, useMemo, useState } from 'react';

import { useApplicationState, useCasinoNewState, useLabel } from '@atlas/core';
import { ChipsItem } from '@atlas/ui';

import { useCasinoFilterState } from 'components/Pages/Casino/CasinoFilterContext';
import {
  casinoFilterTypeMap,
  deleteCasinoFilter,
  updateCasinoFilter,
} from 'components/Pages/Casino/useCasinoFilter';

const FilterChipItemList = ({ setShowFavorites, showFavorites }) => {
  const { authenticated } = useApplicationState();

  const {
    categories: { data: categories },
  } = useCasinoNewState();
  const { filter, updateFilter } = useCasinoFilterState();
  const all = useLabel('all');
  const [title, setTitle] = useState(all);

  const handleScroll = () => {
    const container = document.querySelector('.layout-to-scroll');
    if (container) {
      container.scrollIntoView();
    }
  };

  useEffect(() => {
    if (filter.categories.length) {
      const category = categories.find(({ id }) => id.toString() === filter.categories[0]);
      setTitle(category?.name);
    }
  }, [categories, filter.categories]);

  const onChangeCategory = useCallback(
    categoryId => {
      setShowFavorites(false);
      updateFilter({ categories: [categoryId] });
      updateCasinoFilter(casinoFilterTypeMap.category, categoryId);
    },
    [setShowFavorites, updateFilter],
  );

  const showAllCategories = useCallback(() => {
    setShowFavorites(false);
    deleteCasinoFilter(casinoFilterTypeMap.category);
    setTitle(all);
  }, [all, setShowFavorites]);

  const handleShowFavorites = useCallback(() => {
    setShowFavorites(!showFavorites);
    deleteCasinoFilter(casinoFilterTypeMap.category);
  }, [showFavorites]);

  const sortedCategories = useMemo(
    () => categories.sort((a, b) => a.position - b.position),
    [categories],
  );

  return (
    <>
      <h1 className="d-none">{title}</h1>
      {authenticated && (
        <ChipsItem active={showFavorites} icon="star" onClick={handleShowFavorites} />
      )}
      {sortedCategories.map(category => {
        const { id, name } = category;
        const categoryId = id.toString();
        const active = filter.categories[0] === categoryId;

        const OnChangeCategoryUpdScroll = id => {
          if (active) return;
          onChangeCategory(id);
          handleScroll();
        };

        return (
          <ChipsItem
            active={active}
            key={categoryId}
            label={name}
            onClick={() => OnChangeCategoryUpdScroll(categoryId)}
          />
        );
      })}
      <ChipsItem
        active={!showFavorites && !filter.categories.length}
        label="all"
        onClick={showAllCategories}
      />
    </>
  );
};

export default FilterChipItemList;
